import usePrefix from '@/hooks/usePrefix';
import React from 'react';

const QuickService = ({ children }: { children: React.ReactNode }) => {
  const { prefix, classname } = usePrefix('bicester-account-quick');

  return <div className={classname}>{children}</div>;
};

export default QuickService;
